import { IBooksDetailData } from 'constants/types';

export const getAuthorsLabel = (authors: IBooksDetailData['authors']) => {
  if (Array.isArray(authors) && authors.length > 0) {
    return authors?.map(({ name }) => name)?.join(', ');
  }
  return 'Автор неизвестен';
};

export const getGenresLabel = (genres: IBooksDetailData['genres']) => {
  if (Array.isArray(genres) && genres.length > 0) {
    return genres;
  }
  return [];
};
